import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { ImageService } from './../../dashboard/program-list/image.service';

@Component({
  selector: 'app-file-picker',
  templateUrl: './file-picker.component.html',
  styleUrls: ['./file-picker.component.less']
})

export class FilePickerComponent {
  @Input() pickerId: string;
  @Input() buttonText: string;
  @Input() fileOpts: boolean;
  @Input() uploadType: string; // type of image for s3 upload, else null for server upload
  @Input() currentImageUrl: string; // image to show a thumbnail of
  @Output() postFile: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput;
  public nameOfFile: string;
  public inProgress: boolean = false;

  constructor(private imageService: ImageService) { }

  whatChanged(event: Event, uploadType?: string): void {
    event.stopPropagation();
    let fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      if (uploadType) {
        this.awsPostPhoto(fileToUpload, uploadType);
        this.inProgress = true;
      } else {
        this.postFile.emit(fileToUpload);
      }
      this.nameOfFile = fileToUpload.name;
    }
  }

  private awsPostPhoto(file: File, uploadType: string): void {
    const postData: Object = {
      mime_type: file.type,
      upload_type: uploadType,
      size: file.size
    };
   this.imageService.postImage(postData, file)
                    .subscribe((res) => {
                      let key: string = res.key;
                      let formInput: Object = { key, uploadType };
                      this.postFile.emit(formInput);
                      this.uploadFinished();
                      this.currentImageUrl = res.location;
                    }, error => {
                      console.error(error);
                      this.uploadFinished(error);
                    });
  }

  public uploadFinished(error?: any) {
    this.inProgress = false;
  }
}


// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/file-picker/file-picker.component.ts